// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sCFbYX8tQTJ_HA {
  margin: 0 auto 0 auto;
}
.X3uIl0Hz_2ZDiv {
  text-align: center;
}
.LWteP9RvcwDrJX {
  margin: 0 40px 24px 40px;
  text-align: center;
}
.e4BhyNG28_wGoE {
  margin-block-end: 16px;
  padding: 0;
  color: var(--ds-text, #172b4d);
  font-size: 16px;
}
.QJxTIwqaWk_9I2 {
  margin: 24px auto 0 auto;
}
.mg07MhjLbED49N {
  margin: 0;
}
a.ORAi34z6IRzCu6 {
  color: var(--ds-text-subtle, #44546f);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `sCFbYX8tQTJ_HA`,
	"headerTitle": `X3uIl0Hz_2ZDiv`,
	"subtitle": `LWteP9RvcwDrJX`,
	"boardListTitle": `e4BhyNG28_wGoE`,
	"boardListContainer": `QJxTIwqaWk_9I2`,
	"boardList": `mg07MhjLbED49N`,
	"learnHow": `ORAi34z6IRzCu6`
};
export default ___CSS_LOADER_EXPORT___;
